import { ApiTags, rootApi } from '../../../../../services/rootApi';
import { IPaytmAuthRequest, IPaytmResponse } from './models';

const TAG = ApiTags.Payment;

const payTmApi = rootApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    getPaytmToken: builder.mutation<IPaytmResponse, IPaytmAuthRequest>({
      query: (model) => ({
        url: '/Payments/Paytm',
        method: 'POST',
        body: model
      }),
      invalidatesTags: [TAG]
    })
  })
})

export const {
  useGetPaytmTokenMutation,
} = payTmApi;